<template>
    <div class="col-12">

        <label><strong>{{table.name}}</strong></label>

        <select v-if="!isUserFixed" class="form-select" v-model="document['parent_id']">
            <option v-for="parentOption in parentOptions" :value="parentOption['id']">{{fieldValue(parentOption)}}</option>
        </select>

        <select v-else class="form-select" v-model="document['parent_id']" disabled>
            <option v-for="parentOption in parentOptions" :value="parentOption['id']">{{fieldValue(parentOption)}}</option>
        </select>

    </div>
</template>

<script>
    import DataService from "../../services/DataService";

    export default {
        name: 'SelectParent',
        props: ['table', 'document'],
        data () {
            return {
                model: webase.model,
                service: new DataService(this.table.id),
                parentOptions: []
            }
        },
        computed: {
            primaryField() {
                return webase.utils.table.getPrimaryField(this.table)
            },
            isUser() {
                return this.primaryField && webase.utils.table.isCollaborator(this.primaryField)
            },
            isUserFixed() {
                return this.primaryField && this.primaryField.metadata && this.primaryField.metadata['currentUser']
            },
        },
        mounted () {
            this.service.get().then((response) => {
                this.parentOptions = response

                if(this.isUserFixed) {
                    this.setParentUser()
                }

            }).catch((message) => {
                console.log('error loading data from parent table')
                console.log(message)
            })
        },
        methods: {
            fieldValue (document) {
                return this.isUser ? document[this.primaryField.index].name : document[this.primaryField.index]
            },
            setParentUser() {
                for (let i = 0; i < this.parentOptions.length; i++) {
                    let parentDocument = this.parentOptions[i]
                    let userReference =  parentDocument[this.primaryField.index]

                    if(userReference['id'] === this.model.currentUser.id) {
                        this.document['parent_id'] = parentDocument['id']
                        return
                    }
                }
            }
        }
    }
</script>

<style>

</style>
